export default __webpack_public_path__ + "static/icomoon-261dc0de007819cefae9c370d5111a4e.eot";